export default __webpack_public_path__ + "static/media/undraw_mobile_devices_k1ok.0ba63897.svg";